export default "__VITE_ASSET__BDiFhUkN__"